import { buildWorkflowWriteModelsPrompt } from '@/ai/prompts'
import { fetchJsonResponse, streamJsonResponses } from '@/ai/api'

export const generateWorkflowWriteModels = async ({
  workflow,
  cardTypes,
  stream = true,
  onChunkReceived,
  abortController
}) => {
  if (!workflow || !workflow.aiVersion) {
    return null
  }
  if (stream && typeof onChunkReceived !== 'function') {
    return null
  }

  const { messages, eventIdToLongIdMap } = buildWorkflowWriteModelsPrompt({ workflow, cardTypes })

  if (stream) {
    const response = await streamJsonResponses({
      messages,
      aiVersion: workflow.aiVersion,
      onChunkReceived: (chunk) => onChunkReceived(chunk, eventIdToLongIdMap),
      signal: abortController?.signal
    })

    return [response, messages]
  } else {
    const response = await fetchJsonResponse({
      messages,
      aiVersion: workflow.aiVersion,
      signal: abortController?.signal
    })

    return response || null
  }
}
